module.exports = __webpack_public_path__ + "static/media/intro_wheel.749ac43a.png";